import { render, staticRenderFns } from "./ChangeEmailModal.vue?vue&type=template&id=6e6c185d&scoped=true&"
import script from "./ChangeEmailModal.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c185d",
  null
  
)

export default component.exports